import Text from "./text.marko";
import Play from "./play.marko";
import Picture from "./picture.marko";

<const/v=input.v/>
<const/bare=v.audio && !v.situation && !v.word && !v.say && !v.gap/>
<div class="ll-cx__v" data-g=(v.g || false) data-ll-cx-item data-answer=v.answer data-ll-listen-prompt=(v.audio || false)>
  <div class=["ll-cx__ask", bare && "ll-cx__ask--bare", v.image && "ll-cx__ask--art", v.reply && "ll-cx__ask--reply"]>
    <if=v.image>
      <Picture class="ll-cx__art" image=v.image alt=""/>
    </if>
    <${v.image ? "div" : null} class="ll-cx__beside">
    <if=v.speaker>
      <span class="ll-cx__who">${v.speaker}</span>
    </if>
    <if=v.situation>
      <p class="ll-cx__situation">${v.situation}</p>
    </if>
    <if=(v.lead && !v.reply)>
      <p class="ll-cx__lead">${v.lead}</p>
    </if>
    <if=v.audio>
      <Play src=v.audio big=true label=input.copy.play/>
    </if>
    <if=v.word>
      <p class="ll-cx__word" lang=input.lang dir="auto" data-ll-reveal-audio=(v.wordAudio || false)>${v.word} <Play src=v.wordAudio label=input.copy.play/></p>
    </if>
    <if=v.say>
      <p class="ll-cx__say" lang=input.lang dir="auto" data-ll-reveal-audio=(v.say.audio || false)>
        <Text segs=v.say.segs/>
        <if=v.say.later>
          <span class="ll-cx__reveal" data-ll-reveal hidden><Play src=v.say.audio label=input.copy.play/></span>
        </if>
        <else>
          <Play src=v.say.audio label=input.copy.play/>
        </else>
      </p>
    </if>
    <if=v.gap>
      <p class="ll-cx__say" lang=input.lang dir="auto" data-ll-reveal-audio=(v.reveal?.audio || false)>
        <for|part| of=v.gap>
          <if=part.gap>
            <span class="ll-cx__blank is-active" data-ll-blank>&nbsp;</span>
          </if>
          <else>${part.t}</else>
        </for>
      </p>
    </if>
    <if=v.en>
      <p class="ll-cx__en">${v.en}</p>
    </if>
    <if=v.reply>
      <div class="ll-cx__response">
        <p class="ll-cx__lead">${v.lead}</p>
        <p class="ll-cx__reply" lang=input.lang dir="auto"><span class="ll-cx__answer-slot">
          <for|opt| of=v.options><span class="ll-cx__answer-size" aria-hidden="true">${opt.text}</span></for>
          <span class="ll-cx__blank" data-ll-blank>&nbsp;</span>
        </span></p>
      </div>
    </if>
    </>
  </div>
  <div class=["ll-cx__options", v.gap && "ll-cx__bank"]>
    <for|opt, i| of=v.options>
      <button type="button" class=["ll-cx__opt", v.gap && "ll-cx__chip"] data-ll-opt=i lang=input.lang dir="auto" data-audio=(opt.audio || false)>${opt.text}</button>
    </for>
  </div>
  <if=v.why>
    <p class="ll-cx__why" data-ll-why hidden>${v.why}</p>
  </if>
</div>
